/** SHA-256 con Web Crypto — el mismo hash que recalcula el servidor. */
export async function sha256Hex(datos: ArrayBuffer | Uint8Array): Promise<string> {
  const buffer = datos instanceof Uint8Array ? datos.slice() : new Uint8Array(datos);
  const digest = await crypto.subtle.digest('SHA-256', buffer);
  return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export async function sha256DeBase64(base64: string): Promise<string> {
  const binario = atob(base64);
  const bytes = new Uint8Array(binario.length);
  for (let i = 0; i < binario.length; i++) bytes[i] = binario.charCodeAt(i);
  return sha256Hex(bytes);
}

/** dataURL (p. ej. "data:image/png;base64,....") → solo la parte base64. */
export function base64DeDataUrl(dataUrl: string): string {
  const coma = dataUrl.indexOf(',');
  return coma >= 0 ? dataUrl.slice(coma + 1) : dataUrl;
}

export function uuid(): string {
  return crypto.randomUUID();
}
